import React from "react";
import { nanoid } from "@reduxjs/toolkit";

export const SEClock = () => {
	const id = nanoid();

	return (
		<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="14" cy="14" r="14" fill={`url(#paint_linear_clock_${id})`} />
			<path
				d="M14 8C12.8133 8 11.6533 8.35189 10.6666 9.01118C9.67989 9.67047 8.91085 10.6075 8.45673 11.7039C8.0026 12.8003 7.88378 14.0067 8.11529 15.1705C8.3468 16.3344 8.91825 17.4035 9.75736 18.2426C10.5965 19.0818 11.6656 19.6532 12.8295 19.8847C13.9933 20.1162 15.1997 19.9974 16.2961 19.5433C17.3925 19.0891 18.3295 18.3201 18.9888 17.3334C19.6481 16.3467 20 15.1867 20 14C19.9981 12.4093 19.3654 10.8842 18.2406 9.75943C17.1158 8.63462 15.5907 8.00188 14 8ZM16.022 16.022C15.9197 16.1243 15.781 16.1817 15.6364 16.1817C15.4917 16.1817 15.353 16.1243 15.2507 16.022L13.6144 14.3856C13.5121 14.2834 13.4546 14.1447 13.4545 14V10.7273C13.4545 10.5826 13.512 10.4439 13.6143 10.3416C13.7166 10.2393 13.8553 10.1818 14 10.1818C14.1447 10.1818 14.2834 10.2393 14.3857 10.3416C14.488 10.4439 14.5455 10.5826 14.5455 10.7273V13.7742L16.022 15.2507C16.1243 15.353 16.1817 15.4917 16.1817 15.6364C16.1817 15.781 16.1243 15.9197 16.022 16.022Z"
				fill="#A8A8A8"
			/>
			<defs>
				<linearGradient
					id={`paint_linear_clock_${id}`}
					x1="14"
					y1="0"
					x2="14"
					y2="28"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#C1C1C1" />
					<stop offset="0.0001" stopColor="#EDEDED" />
					<stop offset="1" stopColor="#EDEDED" stopOpacity="0" />
				</linearGradient>
			</defs>
		</svg>
	);
};
